import { Metamodel } from 'app/model/base/model';
import { FormatWriteSettings } from './format-write-settings';
import { OrcDataset } from 'app/model/dataset/orc.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.orc.formatWrite,
    tags: { datasetModel: Metamodel.modelFor(OrcDataset) }
})
export class OrcFormatWriteSettings extends FormatWriteSettings {}
